import { useEffect, useRef } from 'react';
import { usePageContext } from '../usePageContext.ts';
import type { Order } from './orders.ts';

export const useListFollowsStatus = (order: Order | undefined): void => {
  const { invalidate } = usePageContext();
  const seen = useRef<{ id: string; status: string } | null>(null);
  const id = order?.id;
  const status = order?.status;
  useEffect(() => {
    if (id === undefined || status === undefined) return;
    const previous = seen.current;
    seen.current = { id, status };
    if (previous?.id === id && previous.status !== status) void invalidate('orders');
  }, [id, status, invalidate]);
};
